(() => {
  const carouselSelector = '.product-set-upsell';

  function initialise(root = document) {
    root.querySelectorAll(carouselSelector).forEach((carousel) => {
      if (carousel.dataset.paginationReady === 'true') return;

      const viewport = carousel.querySelector('.product-set-upsell__viewport');
      const track = carousel.querySelector('.product-set-upsell__track');
      const cards = Array.from(carousel.querySelectorAll('[data-product-set-upsell-card]'));
      const dots = Array.from(carousel.querySelectorAll('[data-product-set-upsell-dot]'));
      if (!viewport || !track || !cards.length || cards.length !== dots.length) return;

      carousel.dataset.paginationReady = 'true';

      const slideLeft = (card) => card.offsetLeft - track.offsetLeft;
      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          viewport.scrollTo({
            left: slideLeft(cards[index]),
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
          setActive(index);
        });
      });

      let frame = 0;
      viewport.addEventListener(
        'scroll',
        () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = 0;
            let closestIndex = 0;
            let closestDistance = Number.POSITIVE_INFINITY;

            cards.forEach((card, index) => {
              const distance = Math.abs(slideLeft(card) - viewport.scrollLeft);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            setActive(closestIndex);
          });
        },
        { passive: true }
      );

      setActive(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
